var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _vm.showGradient
        ? _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M11.9999 2.3999C6.59192 2.3999 2.3999 6.36125 2.3999 11.7119C2.3999 14.5106 3.54691 16.9291 5.41483 18.5995C5.57165 18.7399 5.6663 18.9365 5.67272 19.1469L5.72499 20.8546C5.74168 21.3993 6.30433 21.7537 6.80278 21.5336L8.70823 20.6925C8.86974 20.6212 9.05075 20.608 9.22097 20.6548C10.0966 20.8956 11.0285 21.0239 11.9999 21.0239C17.4078 21.0239 21.5999 17.0625 21.5999 11.7119C21.5999 6.36121 17.4079 2.3999 11.9999 2.3999Z",
              fill: "url(#paint0_radial_1954_4437)",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.showGradient
        ? _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M11.9999 2.3999C6.59192 2.3999 2.3999 6.36125 2.3999 11.7119C2.3999 14.5106 3.54691 16.9291 5.41483 18.5995C5.57165 18.7399 5.6663 18.9365 5.67272 19.1469L5.72499 20.8546C5.74168 21.3993 6.30433 21.7537 6.80278 21.5336L8.70823 20.6925C8.86974 20.6212 9.05075 20.608 9.22097 20.6548C10.0966 20.8956 11.0285 21.0239 11.9999 21.0239C17.4078 21.0239 21.5999 17.0625 21.5999 11.7119C21.5999 6.36121 17.4079 2.3999 11.9999 2.3999Z",
              fill: "#3A3F48",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M6.23525 14.4349L9.05525 9.96092C9.50383 9.24917 10.4644 9.07195 11.1374 9.57674L13.3803 11.2589C13.5861 11.4133 13.8692 11.4124 14.0742 11.2569L17.1033 8.95802C17.5076 8.6512 18.0354 9.13506 17.7648 9.56444L14.9448 14.0384C14.4962 14.7502 13.5356 14.9274 12.8626 14.4226L10.6197 12.7404C10.4139 12.5861 10.1308 12.5869 9.92585 12.7424L6.89671 15.0413C6.49239 15.3481 5.96461 14.8643 6.23525 14.4349Z",
          fill: "white",
        },
      }),
      _vm._v(" "),
      _c(
        "defs",
        [
          _c(
            "radialGradient",
            {
              attrs: {
                id: "paint0_radial_1954_4437",
                cx: "0",
                cy: "0",
                r: "1",
                gradientUnits: "userSpaceOnUse",
                gradientTransform:
                  "translate(6.0974 21.3668) scale(20.91 20.91)",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#0099FF" } }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.6098", "stop-color": "#A033FF" },
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.9348", "stop-color": "#FF5280" },
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#FF7061" } }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }